var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contactUs publicTop"},[_c('div',{staticClass:"body",staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"top"},[_vm._v("碧莲盛医疗")]),_c('div',{staticClass:"item"},[_vm._v(" 地址："),_c('span',[_vm._v("广东省深圳市福田区沙头街道新华社区滨河路嘉洲豪园裙楼第1、2层02室")])])]),_c('div',{staticClass:"right"})])])
}]

export { render, staticRenderFns }